import axios from 'axios';
import { createAuthHeaders } from '../../api-client';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

export interface SupabaseSecret {
  name: string;
  digest: string;
  updated_at: string;
}

export const secretsApi = {
  /**
   * List all secrets for an OptiDev Cloud project
   * Returns only names and SHA256 digests (values are never retrievable)
   */
  async listSecrets(token: string, projectId: string): Promise<SupabaseSecret[]> {
    const response = await axios.get(
      `${API_URL}/api/supabase/projects/${projectId}/secrets`,
      {
        headers: createAuthHeaders(token),
      }
    );
    return response.data.secrets;
  },

  /**
   * Create multiple secrets at once (bulk create)
   * Secrets are write-only - values cannot be retrieved after creation
   */
  async createSecrets(
    token: string,
    projectId: string,
    secrets: Array<{ name: string; value: string }>
  ): Promise<void> {
    await axios.post(
      `${API_URL}/api/supabase/projects/${projectId}/secrets`,
      { secrets },
      {
        headers: createAuthHeaders(token),
      }
    );
  },

  /**
   * Delete multiple secrets by name (bulk delete)
   */
  async deleteSecrets(
    token: string,
    projectId: string,
    names: string[]
  ): Promise<void> {
    await axios.delete(
      `${API_URL}/api/supabase/projects/${projectId}/secrets`,
      {
        headers: createAuthHeaders(token),
        data: { names },
      }
    );
  },
};
